import { Box, Icon, Tooltip, Typography } from "@outschool/backpack";
import { faQuestionCircle } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import React from "react";

import { useSubscriptionCreditBalance } from "../../hooks/useSubscriptionCreditBalance";

export const MemberPlanDiscountTooltip = () => {
  const { t } = useTranslation(
    "client\\components\\detailPage\\MemberPlanDiscountTooltip"
  );

  const { planSavingsPercentage } = useSubscriptionCreditBalance();
  if (!planSavingsPercentage) {
    return null;
  }

  return (
    <Tooltip
      placement="top"
      title={
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "378px"
          }}
        >
          <Typography variant="subtitle1">
            {t(
              "You save up to {{planSavingsPercentage}}% with your membership. Savings include:",
              {
                planSavingsPercentage
              }
            )}
          </Typography>
          <Typography variant="body2">
            <Box sx={{ display: "inline", margin: "0.5em 0.5em" }}>•</Box>
            {t("No marketplace fees")}
          </Typography>
          <Typography variant="body2">
            <Box sx={{ display: "inline", margin: "0.5em 0.5em" }}>•</Box>
            {t("Free monthly credits")}
          </Typography>
        </Box>
      }
    >
      <Typography
        variant="body1"
        sx={{ color: "success.600", cursor: "pointer" }}
      >
        {t("You save {{planSavingsPercentage}}% as a member", {
          planSavingsPercentage
        })}
        <Icon
          icon={faQuestionCircle}
          sx={{ marginLeft: "0.25em", color: "success.600" }}
        />
      </Typography>
    </Tooltip>
  );
};
